// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"upscale"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 13V21H15M11 3H3V9M11 19V21H9M9 13H11V15M3 15V13H5M3 19V21H5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20.9916 7.94975L20.9635 3.02813L16.0419 3M20.4604 3.53123L14.9502 9.04144","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const UpscaleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'upscale',
    ref,
    icon: element,
  },
));

UpscaleIcon.displayName = 'UpscaleIcon';

export default UpscaleIcon;
